module.exports = __webpack_public_path__ + "static/hw2-128505a122b0230a2458a4893a6a826b.jpg";